import React from 'react'
import './Centre_img.css'
import Blogs from '../Blogs'
import { NavLink } from 'react-router-dom';
const Centre_img = () => {
    return (
    
       
            <main>
              <section class="site-title">
            <div class="site-background" data-aos='fade-up' data-aos-delay="100">
                <h3 style={{fontSize: '3rem'}}>DATA STRUCTURE AND ALGROITHM </h3>
                <h1 style={{fontSize: '2rem'}}>Best Place To Learn </h1>
                <button class="btn" > <NavLink className="inactive" activeClassName="active" to='/category'>Dive-In</NavLink> </button>
            </div>
        </section>
        <section>
            <Blogs/>
            
            </section>
        </main>
       
    )
}

export default Centre_img
